import * as transactionSummaryListActions from './TransactionSummaryList/actions';
import * as createTransactionActions from './CreateTransaction/actions';

export const actions = {
  ...transactionSummaryListActions,
  ...createTransactionActions,
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/state/actions.js